import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { customer } from '@teem/app/core/constants/api';
@Component({
  selector: 'order-detail-accordion',
  templateUrl: './order-detail-accordion.component.html',
  styleUrls: ['./order-detail-accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderDetailAccordionComponent implements OnChanges {
  @Input() order!: any;
  @Input() products: any[] = [];

  isOpen = false;
  orderClass = '';
  visibleCount = 3;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['order'] && changes['order'].currentValue) {
      this.orderClass = this.getOrderClass();
      this.cdr.markForCheck();
    }
  }

  toggleAccordion() {
    this.isOpen = !this.isOpen;
  }

  getOrderClass(): string {
    switch (this.order.status) {
      case 'preparing': return 'preparing';
      case 'paid': return 'paid';
      case 'delivery': return 'delivery';
      case 'complete': return 'complete';
      default: return 'new';
    }
  }

  getImageUrl(productUrl: string) {
    return productUrl ? productUrl : 'images/no-image.png';
  }

  showMoreProducts() {
    this.visibleCount = this.products.length;
  }

  trackByName(index: number, product: any): string {
    return product.name;
  }

  reOrder(uuid){
    window.location.href = customer.reOrderRoute(uuid);
  }
}